import { render, staticRenderFns } from "./RelatorioCotasUnidadeListFiltroModalItem.vue?vue&type=template&id=661f1f2b"
import script from "./RelatorioCotasUnidadeListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasUnidadeListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports